import { Component, OnInit } from '@angular/core';
import { faPowerOff } from '@fortawesome/pro-duotone-svg-icons';
import { faSignOut } from '@fortawesome/pro-duotone-svg-icons/faSignOut';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequiredAgentForSkills } from 'src/app/store/samwin/samwin-skills/required-agents-dto';
import { SamwinSkillsState } from 'src/app/store/samwin/samwin-skills/samwin-skills.state';
import { SessionSelectors } from 'src/app/store/session/session.selectors';
import { ServerCommunicationState } from '../../../store/server-communication/server-communication.state';
import { TerminateAllUserSessions, TerminateCurrentSession } from '../../../store/session/session.actions';

@Component({
   selector: 'samweb-sign-out-dialog',
   templateUrl: './sign-out-dialog.component.html',
   styleUrls: ['./sign-out-dialog.component.scss'],
})
export class SignOutDialogComponent implements OnInit {
   public signOutIcon = faSignOut;
   public closeAllSessionsIcon = faPowerOff;
   public multipleActiveSessions$: Observable<boolean>;
   public understaffedSkillsWithoutAgent$: Observable<RequiredAgentForSkills[]>;
   public isSkillUnderstaffedWithoutAgent$: Observable<boolean>;

   @Select(SessionSelectors.isLogoutDisabled)
   public isLogoutDisabled$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.multipleActiveSessions$ = this.store.select(ServerCommunicationState.getSessionInfos).pipe(map((sessionInfos) => sessionInfos.length > 1));
      this.understaffedSkillsWithoutAgent$ = this.store.select(SamwinSkillsState.getUnderstaffedSkills(true));
      this.isSkillUnderstaffedWithoutAgent$ = this.understaffedSkillsWithoutAgent$.pipe(map((skills) => !_.isEmpty(skills)));
   }

   public signOutCurrentSession() {
      this.store.dispatch(new TerminateCurrentSession());
   }

   public signOutAllSessions() {
      this.store.dispatch(new TerminateAllUserSessions());
   }
}
